module.exports = __webpack_public_path__ + "static/media/Cats eyes 03_FRANSKA-mixdown.56e27611.mp3";